import { render, staticRenderFns } from "./PharmacistUpdateNewUI.vue?vue&type=template&id=7d8bc749&scoped=true&"
import script from "./PharmacistUpdateNewUI.vue?vue&type=script&lang=ts&"
export * from "./PharmacistUpdateNewUI.vue?vue&type=script&lang=ts&"
import style0 from "./PharmacistUpdateNewUI.vue?vue&type=style&index=0&id=7d8bc749&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d8bc749",
  null
  
)

export default component.exports